import { RaidDataBossFight, RaidDataDuel, RaidDataRaid, RaidState } from './types';

export const testData: RaidState<RaidDataRaid> = {
	Settings: {
		CustomEventMessages: ['takes their asthma spray'],
		EnableNotificationSound: true,
		NotificationSoundVolume: 0.05,
		JoinTimer: 16,
		JoinCooldownSeconds: 0,
		Position: {
			X: 14,
			Y: 515,
			Height: 548,
			Width: 470,
		},
		CustomDeathMessages: ['cut themselves on paper'],
		CustomKillMessages: ['killed a slug', 'slipped on slug slime'],
		VoucherDropRate: 10,
		VoucherDropCategories: null,
		MerchCodeDropRate: 1,
		Enabled: true,
	},
	ActiveRaid: {
		Type: 'raid',
		MaxPlayers: 12,
		CountdownSeconds: 20,
		RaidID: 'raid_wi_33yeWXeGw1xY0Xqtk3kyhp',
		Status: 'waiting-for-party',
		Seed: 4095887749659435000,
		Players: [
			{
				UserID: 'twitch:805822595',
				Name: 'Hades32de',
				Level: 9,
				IsPartyHost: true,
				Items: [
					{
						Type: 'title',
						Rarity: 'Rare',
						Title: 'Freischütz',
						Style: 'title',
						Hinge: {
							X: 0,
							Y: 0,
						},
						Size: {
							Width: 0,
							Height: 0,
						},
					},
					{
						Type: 'body_armor',
						Rarity: 'Uncommon',
						SrcURL: 'https://assets.tangia-staging.co/creator_content/user_2EnGsVuHB3rBYLT2nupRTHRVXPJ/dngn_2khgt5B6m747WoXSomwwJgP6xW1_af6a4781064f.svg',
						Title: 'a1',
						Style: 'armor-1',
						Hinge: {
							X: -3,
							Y: 0,
						},
						Size: {
							Width: 15,
							Height: 12,
						},
					},
					{
						Type: 'helmet',
						Rarity: 'Rare',
						SrcURL: 'https://assets.tangia.co/dungeon/bespoke-helmet-3.png',
						Title: 'h1',
						Hinge: { X: -5, Y: -7 },
						Size: { Height: 20, Width: 21 },
						Style: 'custom',
					},
					{
						Type: 'offhand',
						Rarity: 'Common',
						SrcURL: 'https://assets.tangia-staging.co/creator_content/user_2EnGsVuHB3rBYLT2nupRTHRVXPJ/dngn_2kvc676FmHUH87Cl7jYPPKq01hy_0a57b9dab4e8.svg',
						Title: 'Celadon shield',
						Style: 'shield-1',
						Hinge: {
							X: -2,
							Y: 2,
						},
						Size: {
							Width: 12,
							Height: 14,
						},
					},
					{
						Type: 'glove',
						Rarity: 'Epic',
						SrcURL: 'https://assets.tangia-staging.co/creator_content/user_2EnGsVuHB3rBYLT2nupRTHRVXPJ/dngn_2lEofQeaIQi5Y7Uz00LSk6ccFgJ_4b912a3af608.svg',
						Title: 'first gloves',
						Style: 'glove-1',
						Hinge: {
							X: 0,
							Y: 0,
						},
						Size: {
							Width: 7,
							Height: 7,
						},
						SecondaryImage:
							'https://assets.tangia-staging.co/creator_content/user_2EnGsVuHB3rBYLT2nupRTHRVXPJ/dngn_2lEofQeaIQi5Y7Uz00LSk6ccFgJ_78e293f55034.svg',
						SecondarySize: {
							Width: 7,
							Height: 7,
						},
						SecondaryHinge: {
							X: 0,
							Y: 0,
						},
					},
					{
						Type: 'weapon',
						Rarity: 'Rare',
						SrcURL: 'https://assets.tangia.co/dungeon/bespoke-weapon-4.png',
						Title: 'Bow of the Musician',
						Style: 'custom',
						Hinge: {
							X: 6,
							Y: -19,
						},
						Size: {
							Width: 6,
							Height: 29,
						},
					},
				],
				HairStyle: '2',
				HairColor: '#8d3525',
				SkinColor: '#68813b',
			},
		],
		RaidEvents: [
			{ Type: 'message', Message: '⚔️ hades32de killed an Orc' },
			{ Type: 'message', Message: '⚔️ hades32de killed an Orc' },
			{
				BackgroundColor: '#D14EFF',
				BackgroundVideoURL: './gift-animation.webm',
				Description: 'a merch discount code',
				ImageURL: 'https://assets.tangia.co/media-event/merch-code.png',
				Message: 'TangiaDan and found a merch discount code!',
				ShowSeconds: 2,
				Subtitle: 'fewfefwefewfew',
				Title: 'TangiaDan found',
				Type: 'media',
			},
			{ Type: 'message', Message: '🎁 hades32de was rewarded with loot!' },
			{ Type: 'message', Message: '💀 hades32de was killed by a Goblin' },
			{ Type: 'message', Message: '☠️️ Everyone died! ☠️️️' },
			{ Type: 'message', Message: 'hades32de gained 10XP' },
			{ Type: 'message', Message: '⚔️ hades32de killed an Orc' },
			{ Type: 'message', Message: '⚔️ hades32de killed an Orc' },
			{ Type: 'message', Message: '🎁 hades32de was rewarded with loot!' },
			{ Type: 'message', Message: '💀 hades32de was killed by a Goblin' },
			{ Type: 'message', Message: '☠️️ Everyone died! ☠️️️' },
			{ Type: 'message', Message: 'hades32de gained 10XP' },
			{ Type: 'message', Message: '⚔️ hades32de killed an Orc' },
			{ Type: 'message', Message: '⚔️ hades32de killed an Orc' },
			{ Type: 'message', Message: '🎁 hades32de was rewarded with loot!' },
			{ Type: 'message', Message: '💀 hades32de was killed by a Goblin' },
			{ Type: 'message', Message: '☠️️ Everyone died! ☠️️️' },
			{ Type: 'message', Message: 'hades32de gained 10XP' },
			{ Type: 'message', Message: '⚔️ hades32de killed an Orc' },
			{ Type: 'message', Message: '⚔️ hades32de killed an Orc' },
			{ Type: 'message', Message: '🎁 hades32de was rewarded with loot!' },
			{ Type: 'message', Message: '💀 hades32de was killed by a Goblin' },
			{ Type: 'message', Message: '☠️️ Everyone died! ☠️️️' },
			{ Type: 'message', Message: 'hades32de gained 10XP' },
			{ Type: 'message', Message: 'THE END' },
		],
		KilledPlayers: ['twitch:805822595'],
		DungeonImageURL: 'https://assets.tangia.co/dungeon/dungeon-1.png',
		DungeonName: 'affe',
		StartedAt: new Date().toISOString(), //'2024-08-05T08:16:56.8706Z',
	},
};

export const testData2: RaidState<RaidDataRaid> = {
	ActiveRaid: {
		Type: 'raid',
		Seed: 3839162363342838300,
		Events: [
			'🗡️ hades32de slayed his own mirror image +100XP!',
			'🎁 hades32de was rewarded with loot!',
			'🗡️ hades32de slayed his own mirror image +100XP!',
			'🗡️ hades32de defeated a Goblin! +100XP',
			'🎁 hades32de was rewarded with loot!',
			'💀 hades32de died of dysentery',
			'☠️️ Everyone died! ☠️️️',
			'hades32de gained 10XP',
		],
		KilledPlayers: ['twitch:805822595'],
		MaxPlayers: 6,
		StartedAt: new Date().toISOString(), //'2024-08-05T17:19:24.542005Z',
		Players: [
			{
				UserID: 'twitch:805822595',
				Name: 'hades32de',
				IsPartyHost: true,
				HairStyle: '1',
				HairColor: '#777777',
				SkinColor: '#FFFFFF',
				Items: [
					{
						Type: 'body_armor',
						SrcURL: 'https://assets.tangia-staging.co/dngn_XcgOlYNGewI2ioRDWY2ci3',
						Title: 'nice shirt',
						Style: 'armor-1',
						Rarity: 'Common',
						Hinge: {
							Y: 1,
							X: -3,
						},
						Size: {
							Height: 12,
							Width: 15,
						},
					},
					{
						Hinge: {
							X: 5,
							Y: 25,
						},
						Size: {
							Width: 10,
							Height: 14,
						},
						Type: 'weapon',
						Rarity: 'Uncommon',
						SrcURL: 'https://assets.tangia-staging.co/creator_content/user_2EnGsVuHB3rBYLT2nupRTHRVXPJ/dngn_2kEmwlIUcFg3rGL9z51icYPCNBE_925e4c9b5c62.svg',
						Title: 'some sword',
						Style: 'sword-2',
					},
					{
						Size: {
							Height: 0,
							Width: 0,
						},
						Type: 'title',
						Rarity: 'Legendary',
						Title: 'Freischütz',
						Style: 'title',
						Hinge: {
							X: 0,
							Y: 0,
						},
					},
					{
						Size: {
							Width: 13,
							Height: 14,
						},
						Type: 'helmet',
						Rarity: 'Epic',
						SrcURL: 'https://assets.tangia-staging.co/creator_content/user_2EnGsVuHB3rBYLT2nupRTHRVXPJ/dngn_2kEnIDqt47s1GhU24TWMVO91VJ4_88b9a0163244.svg',
						Title: 'protection from above',
						Style: 'helmet-1',
						Hinge: {
							X: 11,
							Y: 10,
						},
					},
					{
						Style: 'shield-2',
						Hinge: {
							X: 5,
							Y: 5,
						},
						Size: {
							Width: 10,
							Height: 14,
						},
						Type: 'offhand',
						Rarity: 'Rare',
						SrcURL: 'https://assets.tangia-staging.co/creator_content/user_2EnGsVuHB3rBYLT2nupRTHRVXPJ/dngn_2kExEtKPtY0sEu5DASHdDwuYLfK_80f090f55048.svg',
						Title: 'moshishield',
					},
				],
			},
		],
		CountdownSeconds: 20,
		DungeonImageURL: 'https://assets.tangia.co/actions/Screenshot%202023-10-02%20at%2011.32.58%E2%80%AFPM_b1cb969b4988.png',
		RaidID: 'raid_wi_Vt0Z7blNOcku1O4fq8oPPT',
		DungeonName: 'The first Tangia Dungeon',
		Status: 'completed',
	},
};

for (let i = 1; i <= 3; i++) {
	testData.ActiveRaid!.Players!.push({
		...testData.ActiveRaid!.Players![0],
		UserID: 'fake' + i,
		Name: 'Faker Nr.' + i,
		IsPartyHost: false,
	});
}
// a few dead
testData.ActiveRaid!.KilledPlayers = testData.ActiveRaid!.Players!.map((player) => player.UserID).filter((_, i) => i > 1);

for (let i = 1; i <= 4; i++) {
	testData2.ActiveRaid!.Players!.push({
		...testData2.ActiveRaid!.Players![0],
		UserID: 'fake' + i,
		Name: 'Faker Nr.' + i,
		IsPartyHost: false,
	});
}
// all dead
testData2.ActiveRaid!.KilledPlayers = testData2.ActiveRaid!.Players!.map((player) => player.UserID);

export const duelTestData: RaidState<RaidDataDuel> = {
	ActiveRaid: {
		MaxPlayers: 2,
		CountdownSeconds: 16,
		ChallengeSeconds: 10,
		ChallengedUserName: 'theRealMrBeast12',
		DungeonImageURL: 'https://assets.tangia.co/dungeon/duel-platform.png',
		Status: 'waiting-for-party', // data is already for completed, we wait for manual click for debugging
		Players: [
			{
				Level: 6,
				IsPartyHost: true,
				HairStyle: '1',
				HairColor: '#777777',
				Infamy: 461,
				UserID: 'user_2gS9iuHNIvPPcnEN0Hvsz1qxT6V',
				Name: 'MR Tangia',
				Items: [],
				SkinColor: '#FFFFFF',
			},
			//testData.ActiveRaid!.Players![1],
		],
		DuelEvents: [
			{
				Health: [100, 85],
				UserID: 'user_2gS9iuHNIvPPcnEN0Hvsz1qxT6V',
				Type: 'attack',
				Message: '15',
			},
			{
				Type: 'attack',
				Message: '10',
				Health: [90, 85],
				UserID: testData.ActiveRaid!.Players![1].UserID,
			},
			{
				UserID: 'user_2gS9iuHNIvPPcnEN0Hvsz1qxT6V',
				Type: 'attack',
				Message: '15',
				Health: [90, 45],
			},
			{
				Type: 'media',
				Title: 'hades32de received',
				ImageURL: 'https://assets.tangia.co/media-event/merch-code.png',
				Description: 'A fancy Epic Sword',
				Subtitle: 'go slay some goblins!',
				BackgroundColor: 'Epic',
				BackgroundVideoURL: './gift-animation.webm',
				ShowSeconds: 2,
			},
			{
				Type: 'media',
				Title: 'hades32de received',
				ImageURL: 'https://assets.tangia.co/media-event/voucher.png',
				Description: 'A fancy dark voucher',
				Subtitle: 'do something special!',
				BackgroundColor: '#323232',
				BackgroundVideoURL: './gift-animation.webm',
				ShowSeconds: 2,
			},
			{
				UserID: testData.ActiveRaid!.Players![1].UserID,
				Type: 'attack',
				Message: '0',
				Health: [90, 45],
			},
			{
				Health: [90, 45],
				UserID: 'user_2gS9iuHNIvPPcnEN0Hvsz1qxT6V',
				Type: 'attack',
				Message: '0',
			},
			{
				UserID: testData.ActiveRaid!.Players![1].UserID,
				Type: 'attack',
				Message: '10',
				Health: [45, 45],
			},
			{
				UserID: 'user_2gS9iuHNIvPPcnEN0Hvsz1qxT6V',
				Type: 'attack',
				Message: '25',
				Health: [45, 20],
			},
			{
				Type: 'attack',
				Message: '45',
				Health: [0, 20],
				UserID: testData.ActiveRaid!.Players![1].UserID,
			},
			{
				UserID: testData.ActiveRaid!.Players![1].UserID,
				Type: 'victory',
				Message: 'MR Tangia is victorious!',
				Health: [0, 20],
			},
			{
				UserID: 'user_2gS9iuHNIvPPcnEN0Hvsz1qxT6V',
				Type: 'infamy',
				Message: '-23',
				Health: null,
			},
			{
				UserID: testData.ActiveRaid!.Players![1].UserID,
				Type: 'infamy',
				Message: '23',
				Health: null,
			},
		],
		Type: 'duel',
		DungeonName: 'kill it with fire',
		StartedAt: new Date().toISOString(),
		Seed: 14279231090395425000,
		RaidID: 'raid_wi_EGM1RPMZ6kdT2TOm1FGoyi',
	},
	ServerTime: new Date().toISOString(),
	Settings: testData.Settings,
};

export const bossFightTestData: RaidState<RaidDataBossFight> = {
	ActiveRaid: {
		MaxPlayers: 10,
		CountdownSeconds: 16,
		DungeonImageURL: 'https://assets.tangia.co/dungeon/duel-platform.png',
		Status: 'waiting-for-party', // data is already for completed, we wait for manual click for debugging
		Type: 'boss',
		DungeonName: 'kill it with fire',
		StartedAt: new Date().toISOString(),
		Seed: 1427923109039,
		RaidID: 'fake-raid-boss-loses',
		Players: [
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-0' },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-1', Name: 'Mr. Faker 1', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-2', Name: 'Mr. Faker 2', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-3', Name: 'Mr. Faker 3', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-4', Name: 'Mr. Faker 4', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-5', Name: 'Mr. Faker 5', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-6', Name: 'Mr. Faker 6', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-7', Name: 'Mr. Faker 7', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-8', Name: 'Mr. Faker 8', IsPartyHost: false },
		],
		BossFightEvents: [
			{
				Type: 'initial',
				BossHealth: 500,
				Message: '',
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 100,
					'fake-2': 100,
					'fake-3': 100,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'fake-0',
				Type: 'attack',
				Message: '0',
				BossHealth: 500,
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 100,
					'fake-2': 100,
					'fake-3': 100,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'fake-1',
				Type: 'attack',
				Message: '45',
				BossHealth: 455,
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 100,
					'fake-2': 100,
					'fake-3': 100,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				TargetUserID: 'fake-1',
				Type: 'attack',
				Message: '55',
				BossHealth: 455,
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 45,
					'fake-2': 100,
					'fake-3': 100,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-3',
				BossHealth: 455,
				Message: '55',
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 45,
					'fake-2': 100,
					'fake-3': 45,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'fake-5',
				Type: 'attack',
				BossHealth: 0,
				Message: '455',
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 45,
					'fake-2': 100,
					'fake-3': 45,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				Type: 'media',
				Title: 'hades32de received',
				ImageURL: 'https://assets.tangia.co/media-event/merch-code.png',
				Description: 'A fancy Epic Sword',
				Subtitle: 'go slay some goblins!',
				BackgroundColor: 'Epic',
				BackgroundVideoURL: './gift-animation.webm',
				ShowSeconds: 2,
			},
			{
				UserID: 'fake-5',
				Type: 'victory',
				Message: 'Chat is victorious!',
				BossHealth: 0,
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 45,
					'fake-2': 100,
					'fake-3': 45,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
		],
	},
	ServerTime: new Date().toISOString(),
	Settings: testData.Settings,
};

export const bossFightCustomBossTestData: RaidState<RaidDataBossFight> = {
	...bossFightTestData,
	ActiveRaid: {
		...bossFightTestData.ActiveRaid!,
		Boss: {
			Name: 'My custom bad Ape Boss with a very very very long name',
			// my ape
			ImageURL: 'https://assets.tangia-staging.co/creator_content/user_2EnGsVuHB3rBYLT2nupRTHRVXPJ/dngn_2kk8VJ25SNGHWF5fHtkies9EWYe_472805bea28c.webp',
		},
	},
};

export const bossFightBossWinsTestData: RaidState<RaidDataBossFight> = {
	ActiveRaid: {
		MaxPlayers: 10,
		CountdownSeconds: 16,
		DungeonImageURL: 'https://assets.tangia.co/dungeon/duel-platform.png',
		Status: 'waiting-for-party', // data is already for completed, we wait for manual click for debugging
		Type: 'boss',
		DungeonName: 'kill it with fire',
		StartedAt: new Date().toISOString(),
		Seed: 1427923109039,
		RaidID: 'fake-raid-boss-wins',
		Players: [
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-0' },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-1', Name: 'Mr. Faker 1', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-2', Name: 'Mr. Faker 2', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-3', Name: 'Mr. Faker 3', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-4', Name: 'Mr. Faker 4', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-5', Name: 'Mr. Faker 5', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-6', Name: 'Mr. Faker 6', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-7', Name: 'Mr. Faker 7', IsPartyHost: false },
			{ ...testData.ActiveRaid!.Players![0], UserID: 'fake-8', Name: 'Mr. Faker 8', IsPartyHost: false },
		],
		BossFightEvents: [
			{
				Type: 'initial',
				BossHealth: 500,
				Message: '',
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 100,
					'fake-2': 100,
					'fake-3': 100,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'fake-0',
				Type: 'attack',
				Message: '0',
				BossHealth: 500,
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 100,
					'fake-2': 100,
					'fake-3': 100,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'fake-1',
				Type: 'attack',
				Message: '45',
				BossHealth: 455,
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 100,
					'fake-2': 100,
					'fake-3': 100,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				TargetUserID: 'fake-1',
				Type: 'attack',
				Message: '55',
				BossHealth: 455,
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 45,
					'fake-2': 100,
					'fake-3': 100,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-3',
				BossHealth: 455,
				Message: '55',
				PlayerHealth: {
					'fake-0': 100,
					'fake-1': 45,
					'fake-2': 100,
					'fake-3': 45,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-0',
				BossHealth: 455,
				Message: '100',
				PlayerHealth: {
					'fake-0': 0,
					'fake-1': 45,
					'fake-2': 100,
					'fake-3': 45,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-1',
				BossHealth: 455,
				Message: '45',
				PlayerHealth: {
					'fake-0': 0,
					'fake-1': 0,
					'fake-2': 100,
					'fake-3': 45,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-2',
				BossHealth: 455,
				Message: '100',
				PlayerHealth: {
					'fake-0': 0,
					'fake-1': 0,
					'fake-2': 0,
					'fake-3': 45,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-3',
				BossHealth: 455,
				Message: '45',
				PlayerHealth: {
					'fake-0': 0,
					'fake-1': 0,
					'fake-2': 0,
					'fake-3': 0,
					'fake-4': 100,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-4',
				BossHealth: 455,
				Message: '100',
				PlayerHealth: {
					'fake-0': 0,
					'fake-1': 0,
					'fake-2': 0,
					'fake-3': 0,
					'fake-4': 0,
					'fake-5': 100,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-5',
				BossHealth: 455,
				Message: '100',
				PlayerHealth: {
					'fake-0': 0,
					'fake-1': 0,
					'fake-2': 0,
					'fake-3': 0,
					'fake-4': 0,
					'fake-5': 0,
					'fake-6': 100,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-6',
				BossHealth: 455,
				Message: '100',
				PlayerHealth: {
					'fake-0': 0,
					'fake-1': 0,
					'fake-2': 0,
					'fake-3': 0,
					'fake-4': 0,
					'fake-5': 0,
					'fake-6': 0,
					'fake-7': 100,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-7',
				BossHealth: 455,
				Message: '100',
				PlayerHealth: {
					'fake-0': 0,
					'fake-1': 0,
					'fake-2': 0,
					'fake-3': 0,
					'fake-4': 0,
					'fake-5': 0,
					'fake-6': 0,
					'fake-7': 0,
					'fake-8': 100,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-8',
				BossHealth: 455,
				Message: '100',
				PlayerHealth: {
					'fake-0': 0,
					'fake-1': 0,
					'fake-2': 0,
					'fake-3': 0,
					'fake-4': 0,
					'fake-5': 0,
					'fake-6': 0,
					'fake-7': 0,
					'fake-8': 0,
					'fake-9': 100,
				},
			},
			{
				UserID: 'boss',
				Type: 'attack',
				TargetUserID: 'fake-9',
				BossHealth: 455,
				Message: '100',
				PlayerHealth: {
					'fake-0': 0,
					'fake-1': 0,
					'fake-2': 0,
					'fake-3': 0,
					'fake-4': 0,
					'fake-5': 0,
					'fake-6': 0,
					'fake-7': 0,
					'fake-8': 0,
					'fake-9': 0,
				},
			},
			{
				UserID: 'boss',
				Type: 'victory',
				Message: 'Chat is a bunch of losers!',
				BossHealth: 455,
				PlayerHealth: {
					'fake-0': 0,
					'fake-1': 0,
					'fake-2': 0,
					'fake-3': 0,
					'fake-4': 0,
					'fake-5': 0,
					'fake-6': 0,
					'fake-7': 0,
					'fake-8': 0,
					'fake-9': 0,
				},
			},
		],
	},
	ServerTime: new Date().toISOString(),
	Settings: testData.Settings,
};
